module.exports = __webpack_public_path__ + "img/hidePic.4182837a.svg";